<script lang="ts">
  import { getContext } from 'svelte';
  import { twMerge } from 'tailwind-merge';
  import type { CarouselContext } from './types';

  const { slideIds } = getContext<CarouselContext>('carousel-context');
  const id: string = `slide-${crypto.randomUUID()}`;

  slideIds.update((ids) => [...ids, id]);
</script>

<div
  {id}
  class={twMerge('carousel-slide min-h-full min-w-full snap-center snap-always', $$restProps.class)}
>
  <slot />
</div>
